import {mixins} from 'vue-chartjs'
import Chart from 'chart.js';
import _ from 'lodash';

const chart = {
  mixins: [mixins.reactiveData],
  props: ['data', 'opts', 'axis', 'colors', 'setopts'],
  computed: {
    options () {
      var defaultopts = {
        legend: {
          display: false,
        },
        animation: {
          duration: 0,
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              min: 0,
            },
            gridLines: {
              borderDash: [3, 20],
              lineWidth: 3,
              drawBorder: false,
            },
          }],
          xAxes: [{
            gridLines: {
              display: false,
            },
          }],
        },
        responsive: true,
        maintainAspectRatio: false,
      };
      if (typeof this.opts === 'object') {
        _.mergeWith(defaultopts, this.opts, function (obj, src) {
          if (Array.isArray(obj) && Array.isArray(src)) {
            var isAllNumeric = true;
            for (let i of obj) {
              if (typeof i !== 'number') {
                isAllNumeric = false;
                break;
              }
            }
            for (let i of src) {
              if (typeof i !== 'number') {
                isAllNumeric = false;
                break;
              }
            }
            if (isAllNumeric) {
              return src;
            }
          }
        });
      }
      return defaultopts;
    },
    width () {
      return this.opts && this.opts.width || '100%';
    },
    height () {
      return this.opts && this.opts.height || '100%';
    },
  },
  watch: {
    data () {
      this.recompute();
    },
    axis () {
      this.recompute();
    },
  },
  methods: {
    recompute () {
      if (!this.data) {
        return;
      }
      var composit = {
        labels: [],
        datasets: [],
      };
      if (this.axis) {
        composit.labels = this.axis;
      }
      if (Array.isArray(this.data) && !(typeof this.data[0] === 'object')) {
        //is array of numbers
        composit.datasets = [{data: this.data}];
      } else if (Array.isArray(this.data) && typeof this.data[0] === 'object' && !Array.isArray(this.data[0])) {
        //is array of objects
        composit.datasets = this.data;
      } else if (typeof this.data === 'object') {
        //is object
        composit.datasets = [this.data];
      } else {
        composit.datasets = this.data;
      }
      var colors = [
        '88, 201, 145', //green
        '255, 162, 84', //orange
        '254, 115, 120',//red
      ];
      if (this.colors) {
        colors = this.colors;
      }
      var setopts = this.setopts || {};
      //add default vars
      composit.datasets.forEach((set, i, sets) => {
        sets[i] = Object.assign({
          borderColor: 'rgb(' + colors[i % colors.length] + ')',
          backgroundColor: 'rgba(' + colors[i % colors.length] + ', 0.3)',
          borderWidth: 4,
          pointBorderWidth: 13,
          lineTension: 0,
          pointHitRadius: 15,
        }, setopts, set)
      });
      this.chartData = composit;
    }
  },
  mounted () {
    this.recompute();
    this.renderChart(this.chartData, this.options);
    if (this.height) {
      this.$el.style.height = this.height;
    }
    if (this.width) {
      this.$el.style.width = this.width;
    }
    var resize = () => {
      if (this.height === '100%' && this.$el.parentNode) {
        this.$el.style.height = this.$el.parentNode.offsetHeight;
      }
      if (this.width === '100%' && this.$el.parentNode) {
        this.$el.style.width = this.$el.parentNode.offsetWidth;
      }
    }
    if (this.height === '100%' || this.width === '100%') {
      window.addEventListener('resize', resize);
    }
    resize();
  }
};

export default chart;


// WEBPACK FOOTER //
// ./src/helpers/components/charts/chart.js